import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class MensalidadeService extends Service {
  async consultarMensalidades (mes, ano) {
    let mensalidades = [];
    const brancoAcoes = '';
    let result = await this.getMensalidadeApi().consultarMensalidades(mes, ano);
    result.map(res => {
      const { numSeqMensalidade, numAnoInicio, numMesInicio, numAnoFim, numMesFim, dtaInicio, dtaFim, codUsuarioCadastro, dtaCadastro, qtdeRegistrosComValorZerado, valorSeguro } = res;
      mensalidades.push(Object.values({ numSeqMensalidade, numAnoInicio, numMesInicio, numAnoFim, numMesFim, dtaInicio, dtaFim, codUsuarioCadastro, dtaCadastro, qtdeRegistrosComValorZerado, valorSeguro, brancoAcoes }));
    });
    return mensalidades || [];
  }
  async consultarValoresMensalidade (numSeqMensalidade, apenasValoresZerados) {
    let valoresMensalidade = [];
    let result = await this.getMensalidadeApi().consultarValoresMensalidade(numSeqMensalidade, apenasValoresZerados);
    result.map(res => {
      const { seqMensalidade, seqValor, codTipoMensalidade, desTipoMensalidade, seqRemuneracao, desRemuneracao, seqIdade, desIdade, codUsuarioCadastro, valMensalidade, dtaCadastro } = res;
      valoresMensalidade.push(Object.values({ seqMensalidade, seqValor, codTipoMensalidade, desTipoMensalidade, seqRemuneracao, desRemuneracao, seqIdade, desIdade, codUsuarioCadastro, valMensalidade, dtaCadastro }));
    });
    return valoresMensalidade || [];
  }
  async excluirMensalidade (seqMensalidade) {
    let result = await this.getMensalidadeApi().excluirMensalidade(seqMensalidade);
    return result;
  }
  async consultarUltimaMensalidade () {
    let ultimaMensalidade = await this.getMensalidadeApi().consultarUltimaMensalidade();
    return ultimaMensalidade;
  }
  async incluirMensalidade (reajuste) {
    let result = await this.getMensalidadeApi().incluirMensalidade(reajuste);
    return result;
  }
  async salvarValorMensalidade (valorMensalidade) {
    let result = await this.getMensalidadeApi().salvarValorMensalidade(valorMensalidade);
    return result;
  }
  async consultarSeguro (seqMensalidade) {
    let valorSeguro = await this.getMensalidadeApi().consultarSeguro(seqMensalidade);
    return valorSeguro;
  }
}
export default MensalidadeService;
